import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

const terrainOptions = [
    'Pavement',
    'Dirt',
    'Sand',
    'Snow/ice',
    'Rocks',
    'Water Crossings',
    'Shelf Roads',
    'Off Camber',
    'Mud',
    'Pinstriping',
    'Technical Obstacles'
].map(t => ({ value: t, label: t }));

const TerrainSelect = ({ selectedTerrain, setSelectedTerrain }) => {
    const handleChange = useCallback((selectedOptions) => {
        const newValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setSelectedTerrain(newValues);
    }, [setSelectedTerrain]);

    // Memoize the value calculation to prevent unnecessary recalculations
    const value = useMemo(() => {
        // Ensure selectedTerrain is always an array
        const terrain = Array.isArray(selectedTerrain) ? selectedTerrain : [];
        return terrainOptions.filter(opt => terrain.includes(opt.value));
    }, [selectedTerrain]);

    return (
        <div style={{ marginBottom: '1rem' }}>
            <label className="block mb-1 text-sm font-bold">Terrain (select one or more)</label>
            <Select
                options={terrainOptions}
                isMulti
                value={value}
                onChange={handleChange}
                placeholder="Select terrain types"
                isSearchable
                // Add a key to help React identify this component
                key="terrain-select"
            />
        </div>
    );
};

export default TerrainSelect;